module.exports = __webpack_public_path__ + "img/nature-soundscapes.e806c63e.png";